/*------------------------------------------------- FUNCTIONS -------------------------------------------------*/
/*-------------------------------------------------  PUBLIC  -------------------------------------------------*/

export function BaseLoginPageState(config) {
    if (config) {
        this.buttonId = config.buttonId
        this.progressTextId = config.progressTextId
        this.inputElementNames = config.inputElementNames
        this.focusElementName = config.focusElementName
        this.formId = config.formId
        this.formContainerId = config.formContainerId
        this.changeStateLinkId = config.changeStateLinkId
        this.controller = null
        this.changeStateLinkContainerId = config.changeStateLinkContainerId
        this.titleKey = config.titleKey
    }

    // Protected
    this.timerId = null
    this.toSubmit = true
}

    BaseLoginPageState.prototype.setController = function( controller ) {
        this.controller = controller;
    };

    BaseLoginPageState.prototype.getDemoTooltip = function( ) {
        return LoginPage.DEMO_TOOLTIP;
    };

    BaseLoginPageState.prototype.getNote = function( ) {
        return null;
    };

    BaseLoginPageState.prototype.submitForm = function( )
    {
        var controller = this.controller;
        var state = this;
        var form = controller.getForm();
        if( controller.isInProgress() )
            return;
        controller.toInProgressState();
        this.prepareForSubmit();
        this.doSubmit( form );
        this.timerId = window.setTimeout( function(){
            TransformedScreenMoire.hide();
            state.processError(state.getTimeoutMessage());
        }, LoginPage.BROWSER_TIMEOUT_MINUTES * 60000);
    };

    /*
     * Performs actions need to be done on page submition
     * NOTE: method need to be overridden be inheritors
     */
    BaseLoginPageState.prototype.doSubmit = function( form )
    {
        // Do nothing by default
    };

    /*
     * Performs server remote procedure call.
     */
    BaseLoginPageState.prototype.makeRemoteCall = function(form, serviceMethodName, processSuccessFunc, processErrorFunc, remoteCall) {
        var state = this;
        try
        {
            if (!isRpcReady( [serviceMethodName] ))
            {
                var func = function(){ state.makeRemoteCall(form, serviceMethodName, processSuccessFunc, processErrorFunc, remoteCall);};
                window.setTimeout(func, 200);
                return;
            }

            var callback = function(result, exception)
            {
                if (!exception && state.toSubmit)
                    processSuccessFunc.call(state, form, result);
                else
                    processErrorFunc.call(state, exception);
            };

            remoteCall( callback );
        }
        catch (e)
        {
            processErrorFunc.call(state, e);
        }
    };

    /*
     * Clears form's inputs
     * NOTE: method need to be overridden be inheritors
     */
    BaseLoginPageState.prototype.clearInputs = function( form )
    {
        // Do nothing by default
    };

    /*
     * Returns page to initial state and shows the error message.
     */
    BaseLoginPageState.prototype.processError = function(errorMessage) {
        this.clearServerRequest();
        this.controller.hideServerSideMessages();
        this.controller.printError( errorMessage );
        ClientSideErrors.showClientSideErrorMessage();
    };

    BaseLoginPageState.prototype.clearServerRequest = function() {
        this.toSubmit = false;
        this.controller.toInitialState();
        window.clearTimeout(this.timerId);
        this.timerId = null;
        this.stopLoad();
    };

    /*
     * Do some initializations and functions callings to prepare for form submission.
     */
    BaseLoginPageState.prototype.prepareForSubmit = function() {
        this.toSubmit = true;
        ClientSideErrors.hideClientSideErrorMessage();
        ClientSideErrors.errorMessageWasShown = false;
    };

    /*
     * Stops page loading (login action).
     */
    BaseLoginPageState.prototype.stopLoad = function() {
        try {
            window.stop();
        } catch (e) {
            // Can be thrown in IE because of window.stop(); statement.
            window.document.execCommand('Stop');
        }
    };

//  LoginState section of Login Page Interface
export function LoginState(config) {
    BaseLoginPageState.call(this, config)
    this.showAdminManagerTooltip = config.showAdminManagerTooltip
    this.showPasswordResetTooltip = config.showPasswordResetTooltip
    this.isDemoMode = config.showPasswordResetTooltip

    // Private
    this.userPassword = null
}

    LoginState.prototype = new BaseLoginPageState();

    LoginState.prototype.getTitle = function( ) {
        return messageResource.getMessage("login.form.title", [], true);
    };

    LoginState.prototype.getTooltip = function( )
    {
        var tooltip = "";
        if( this.showPasswordResetTooltip )
            tooltip += this.getPasswordSuccessfullyResetTooltip();
        if( this.showAdminManagerTooltip )
            tooltip += this.getAdminManagerTooltip();

        return tooltip;
    };

    LoginState.prototype.getAdminManagerTooltip = function( ) {
        return LoginPage.ADMIN_MANAGER_TOOLTIP;
    };

    LoginState.prototype.getPasswordSuccessfullyResetTooltip = function( ) {
        this.showPasswordResetTooltip = false;
        return LoginPage.PASSWORD_SUCCESSFULLY_RESET_TOOLTIP;
    };

    LoginState.prototype.doSubmit = function( form )
    {
        BaseLoginPageState.prototype.doSubmit.call( this, form );
        this.rememberPassword(form);
        this.doGetChallenge(form);
    };

    LoginState.prototype.clearInputs = function( form )
    {
        $( form.elements['pwd'] ).pVal( "" );
        $( form.elements['username'] ).pVal( "" );
    };

    //--  PRIVATE methods --
    /*
     * Remembers typed by user password and cleans appropriate field.
     */
    LoginState.prototype.rememberPassword = function (form) {
        //placeholder IE8 bug workaround
        var pwdInput = form.elements['pwd'][1] || form.elements['pwd'];
        this.userPassword = pwdInput.value;
        form.elements['pwd'].value = "";
    };

    /*
     * Do GET-request to get challenge anf if challenge has been got calls doLogin() function.
     */
    LoginState.prototype.doGetChallenge = function(form) {
        var state = this;
        this.makeRemoteCall( form, 'LoginService.getChallenge',
                             state.doLogin,
                             state.processGetChallengeError,
                             function( callback ){
                                 jsonrpc.LoginService.getChallenge(callback);
                             } );
    };

    LoginState.prototype.processGetChallengeError = function(exception) {
        this.processError( this.getErrorMessage() );
    };

    /*
     * Gets message informing about login failure.
     */
    LoginState.prototype.getErrorMessage = function() {
        return messageResource.getMessage("login.failed_to_login", [], true);
    };

    /*
     * Gets message informing about timeout exceeding.
     */
    LoginState.prototype.getTimeoutMessage = function() {
        return messageResource.getMessage("login.timeout_login", [LoginPage.BROWSER_TIMEOUT_MINUTES], true);
    };

    /*
     * Posts form to login.
     */
    LoginState.prototype.doLogin = function(form, result)
    {
        form.elements['submitted'].value = 1;
        form.elements['password'].value  = MD5(MD5(this.userPassword) + result.challengeValue + trim(form.elements['username'].value).toLowerCase());

        this.rewriteJsessionidIfNeeded(form, result.sessionId);

        // hide screen with moire after start login
        TransformedScreenMoire.showAndTransformTo("loginMoire", 1, "1s", "ease-in-out");

        form.submit();
    };

    /*
     * Rewrites URL jsessionid parameter if URL rewriting is used to keep session. It is needed when session has expired on
     * the server and to login form action should contain right jsessionid parameter.
     */
    LoginState.prototype.rewriteJsessionidIfNeeded = function(form, newSessionId) {
        var jsessionidPos = form.action.indexOf("jsessionid");
        if (jsessionidPos >= 0) {
            var formAction = form.action;
            var currentSessionId = formAction.substring(formAction.indexOf("=", jsessionidPos) + 1);

            form.action = formAction.replace(currentSessionId, newSessionId);
        }
    };

// --  ForgetPasswordState section of Login Page Interface  --
export function ForgetPasswordState(config) {
    BaseLoginPageState.call(this, config)
}

    ForgetPasswordState.prototype = new BaseLoginPageState();

    ForgetPasswordState.prototype.doSubmit = function( form )
    {
        BaseLoginPageState.prototype.doSubmit.call( this, form );
        this.doRequestLoginInfo(form);
    };

    ForgetPasswordState.prototype.clearInputs = function( form )
    {
        $('#forgetPasswordEmailOrUsername' ).val("");
        //IE8 jquery.placeholder bug
        $('#forgetPasswordEmailOrUsername' ).removeClass('placeholder');

    };

    /*
     * Do request login information to be sent to the user with given username or email address.
     */
    ForgetPasswordState.prototype.doRequestLoginInfo = function(form) {
        var state = this;
        if (isAT)
        {
            this.makeRemoteCall( form, 'ATPasswordRecoveryService.sendLoginInfo',
                                 state.doProcessResponse,
                                 state.processRequestLoginInfoError,
                                 function ( callback )
                                 {
                                     var userNameOrEmail = form.elements['forgetPasswordEmailOrUsername'].value;
                                     jsonrpc.ATPasswordRecoveryService.sendLoginInfo( callback, userNameOrEmail );
                                 } );
        }
        else
        {
            this.makeRemoteCall( form, 'APPasswordRecoveryService.sendLoginInfo',
                                 state.doProcessResponse,
                                 state.processRequestLoginInfoError,
                                 function ( callback )
                                 {
                                     var userNameOrEmail = form.elements['forgetPasswordEmailOrUsername'].value;
                                     jsonrpc.APPasswordRecoveryService.sendLoginInfo( callback, userNameOrEmail );
                                 } );
        }
    };

    ForgetPasswordState.prototype.doProcessResponse = function(form, response)
    {
        if( response.success )
        {
            this.clearServerRequest();
            this.controller.hideAllMessages();
            this.controller.printTooltip( this.getSuccessTooltip( response.message ) );
            this.controller.printNote( response.note );
            this.controller.hideForm();
        }
        else
        {
            this.processRequestLoginInfoError( null, response );
        }
    };

    ForgetPasswordState.prototype.processRequestLoginInfoError = function(exception, response)
    {
        var controller = this.controller;
        var state = this;
        var errorNote = response === undefined ? state.getErrorNote() : response.note;
        var errorMessage = response === undefined ? state.getErrorMessage() : response.message;
        this.processError( errorMessage );
        window.setTimeout( function(){
            controller.printNote( errorNote );
            controller.printTooltip( null ); },
        200 );
    };

    ForgetPasswordState.prototype.getTitle = function( ) {
        return messageResource.getMessage("password_recovery.forgot_your_password", [], true);
    };

    ForgetPasswordState.prototype.getTooltip = function( ) {
        return '<div class="plainTextTooltip">' + messageResource.getMessage("password_recovery.forgot_your_password.tooltip", [], true) + '</div>';
    };

    ForgetPasswordState.prototype.getErrorMessage = function() {
        return messageResource.getMessage("password_recovery.forgot_your_password.send_info.failed", [], true);
    };

    ForgetPasswordState.prototype.getTimeoutMessage = function() {
        return messageResource.getMessage("password_recovery.forgot_your_password.send_info.timeout", [LoginPage.BROWSER_TIMEOUT_MINUTES], true);
    };

    ForgetPasswordState.prototype.getErrorNote = function() {
        return messageResource.getMessage("password_recovery.forgot_your_password.send_info.failed.note.without_email");
    };

    ForgetPasswordState.prototype.getSuccessTooltip = function( message ) {
        var noteTemplate = LoginPage.LOGIN_INFO_SUCCESSFULLY_SENT_TOOLTIP;
        return messageResource.applyParamsSubstitutions( noteTemplate, [ message ], 0 );
    };

// --  ResetPasswordState section of Login Page Interface  --
export function ResetPasswordState(config) {
    BaseLoginPageState.call(this, config)
    this.tooltipText = config.tooltipText

    if (PASSWORD_ERROR_JSON) {
        this.postponedError = PasswordPolicyManager.getErrorMessage(PASSWORD_ERROR_JSON)
    }

    this.newPassword = null
    this.newPasswordConfirm = null
    this.newPasswordText = null
    this.newPasswordConfirmText = null
    this.passwordPolicy = PasswordPolicyManager
}

    ResetPasswordState.prototype = new BaseLoginPageState();

    ResetPasswordState.prototype.initFieldControllers = function( )
    {
        if( this.newPassword )
            return;
        this.newPassword = document.getElementById( "newPassword" );
        this.newPasswordConfirm = document.getElementById( "newPasswordConfirm" );
        //placeholder IE8 bug workaround
        this.newPasswordText = resetPasswordForm.elements['newPwd'][1] ||  resetPasswordForm.elements['newPwd'];
        this.newPasswordConfirmText = resetPasswordForm.elements['newPwdConfirm'][1] ||  resetPasswordForm.elements['newPwdConfirm']; document.getElementById( "newPwdConfirm" );
    };

    ResetPasswordState.prototype.doSubmit = function( form )
    {
        BaseLoginPageState.prototype.doSubmit.call( this, form );
        this.doResetPassword( form );
    };

    ResetPasswordState.prototype.doResetPassword = function( form )
    {
        var state = this;

        var submitFunc = function(){
            state.initFieldControllers();
            state.verifyPasswords().then(() => {
                state.newPassword.value = state.newPasswordText.value;
                state.newPasswordConfirm.value = state.newPasswordConfirmText.value;
                state.clearInputs( form );
                state.clearServerRequest();
                form.submit();
            }).catch(errorMessage => {
                state.processError( errorMessage );
            });
        };
        window.setTimeout(submitFunc, 200);
    };

    ResetPasswordState.prototype.clearInputs = function( form )
    {
        form.elements['newPwd'].value = "";
        form.elements['newPwdConfirm'].value = "";
    };

    ResetPasswordState.prototype.verifyPasswords = function() {
        var password = this.newPasswordText.value;
        var passwordCopy = this.newPasswordConfirmText.value;
        if( !(password.length > 0) )
            return Promise.reject(messageResource.getMessage("password_recovery.reset_password.password_empty", [], true));

        const ErrorMessagesMap = {
            [PasswordAsyncValidator.ValidationErrors.PASSWORD_EMPTY]: () => messageResource.getMessage("password_recovery.reset_password.password_empty"),
            [PasswordAsyncValidator.ValidationErrors.PASSWORD_COPY_EMPTY]: () => messageResource.getMessage("password_recovery.reset_password.password_empty"),
            [PasswordAsyncValidator.ValidationErrors.PASSWORDS_DO_NOT_MATCH]: () => messageResource.getMessage("password_recovery.reset_password.passwords_do_not_match"),
            [PasswordAsyncValidator.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]: (json) => PasswordPolicyManager.getErrorMessage(json),
        }

        return new Promise((resolve, reject) => {
            getPasswordValidator({
                onValidationEnd: function(errorCode, json) {
                    if (!errorCode) {
                        resolve();
                    } else {
                        reject(ErrorMessagesMap[errorCode](json));
                    }
                }
            }).setState({password, passwordCopy})

        });
    };

    ResetPasswordState.prototype.getTitle = function( ) {
        return isAT ?
            messageResource.getMessage("password_recovery.reset_password", [], true) :
            messageResource.getMessage("actiplans.password_recovery.reset_password", [], true);
    };

    ResetPasswordState.prototype.newClickTooltip = function() {
        return new PasswordHintTooltip(this.passwordPolicy, {dialogOffsets: {left: 15, top: 0}});
    }

    ResetPasswordState.prototype.getTooltip = function() {
        return '<div class="plainTextTooltip">' +
                   this.tooltipText +
                   (this.passwordPolicy.hasPasswordRequirements() ? (
                   '<span class="passwordHintLink" id="hover_tooltip">' +
                       messageResource.getMessage('password_recovery.reset_password.password_requirements') +
                       '<span class="img"></span>' +
                   '</span>'
                   ) : '') +
               '</div>'
    }

    ResetPasswordState.prototype.getTimeoutMessage = function() {
        return messageResource.getMessage("password_recovery.reset_password.timeout", [LoginPage.BROWSER_TIMEOUT_MINUTES], true);
    };

    // --  ErrorState section of Login Page Interface  --
export function ErrorState(config) {
    BaseLoginPageState.call(this, config)
    this.message = config.message
}

    ErrorState.prototype = new BaseLoginPageState();

    ErrorState.prototype.getTitle = function( ) {
        return null;
    };

    ErrorState.prototype.getTooltip = function( ) {
        return '<div class="errorTooltip">' + this.message + '</div>';
    };

    ErrorState.prototype.getErrorMessage = function() {
        return message;
    };




// WEBPACK FOOTER //
// ./web/js/login.js